export const ENGLISH = 'en';